import React, { useEffect, useState } from "react";
import {
  ChoosePlanCard,
  FormField,
  FormInput,
  FormContainer,
  FormRow,
  ConfirmButton,
  PlansDropdown,
  DependentsButton,
} from "../../styles/PFform";
import styled from "styled-components";
import { getCities, sendFormFunction } from "../../data/services/form_contract";
import { CrewStyle } from "../../styles/PFform";
import { WrapContent } from "../../styles/PFform";
import {
  getContractAssociatedInfo,
  getContractInfo,
  getIdContract,
  setIdCategory,
} from "../../data/services/crew_service";
import ContractModel from "../../data/models/contract";
import SuccessDialog2 from "../../components/SuccessDialog2";
import axios from "axios";
import { endpoint } from "../../utils/constants";
import { attInfoPF } from "../../data/services/person_service";
import { BackButton } from "../../styles/AddAdherense";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { HOME_LOGGED } from "../../core/app-urls";

const BlurWrapper = styled.div<{ isBlurred: boolean }>`
  filter: ${(props) => (props.isBlurred ? "blur(5px)" : "none")};
  width: 100%;
  height: 100%;
`;

export default function AttInfos() {
  const [plans, setPlans] = useState<ContractModel["planos"]>([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [contractData, setContractData] = useState<any>(null);
  const [municipios, setMunicipios] = useState<any>([]);
  const [estados, setEstados] = useState<Set<string>>(new Set());
  const [dependents, setDependents] = useState<
    { nome: string; telefone: string; cpf: string; email: string }[]
  >([]);
  const [formData, setFormData] = useState({
    nome: "",
    cpf: "",
    telefone: "",
    email: "",
    cep: "",
    rua: "",
    bairro: "",
    numero: "",
    cidade: "",
    estado: "",
  });
  const navigate = useNavigate();

  const [documentoFrente, setDocumentoFrente] = useState<File | null>(null);
  const [documentoVerso, setDocumentoVerso] = useState<File | null>(null);

  const handleFileChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    tipo: "frente" | "verso"
  ) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      if (tipo === "frente") {
        setDocumentoFrente(file);
      } else {
        setDocumentoVerso(file);
      }
    }
  };

  const handleButtonClick = (tipo: "frente" | "verso") => {
    if (tipo === "frente") {
      document.getElementById("uploadFrente")?.click();
    } else {
      document.getElementById("uploadVerso")?.click();
    }
  };

  useEffect(() => {
    async function loadInitialData() {
      try {
        const idContract = getIdContract();

        const [contractInfo, municipiosInfo] = await Promise.all([
          getContractInfo(idContract),
          getCities(),
        ]);

        // --- PLANOS ---
        if (contractInfo?.contract) {
          setContractData(contractInfo.contract);
          setPlans(contractInfo.contract.planos || []);
        }

        // --- MUNICÍPIOS ---
        if (municipiosInfo) {
          setMunicipios(municipiosInfo.cities);
          setEstados(new Set(municipiosInfo.states));
        }
      } catch (error) {
        console.error("Erro ao carregar dados iniciais:", error);
      }
    }

    loadInitialData();
  }, []);

  useEffect(() => {
    if (municipios.length === 0) return; // evita rodar sem os municípios

    async function loadCpfData() {
      try {
        const cpf = localStorage.getItem("cpf_cnpj");
        if (!cpf) return;

        const { contract } = await getContractAssociatedInfo(cpf);
        if (!contract) {
          alert("Nenhum contrato associado encontrado para o CPF informado.");
          return;
        }

        // -------------------------
        // Encontrar cidade pelo ID
        // -------------------------
        const cidadeEncontrada = municipios.find(
          (m: any) => String(m.codigo) === String(contract.idCidade)
        );

        const cidadeCodigo = cidadeEncontrada?.codigo ?? "";
        const estadoSigla = cidadeEncontrada?.uf ?? "";

        // -------------------------
        // Preencher tudo de forma segura
        // -------------------------
        setFormData({
          nome: contract.nome || "",
          telefone: contract.telefoneEmp || "",
          email: contract.emailCob || "",
          cep: contract.cep || "",
          rua: contract.logradouro || "",
          bairro: contract.bairro || "",
          numero: contract.numero || "",
          estado: estadoSigla, // ← agora seleciona o UF correto
          cidade: cidadeCodigo, // ← agora seleciona a cidade correta
          cpf,
        });
      } catch (error) {
        console.error("Erro ao buscar informações pelo CPF:", error);
      }
    }

    loadCpfData();
  }, [municipios]); // ← EXECUTA SOMENTE quando municipios estiver carregado

  const uploadFile = async (file: File) => {
    const formData = new FormData();
    formData.append("files", file);

    // try {
    //   const response = await axios.post(
    //     `${endpoint}/upload/documents`,
    //     formData,
    //     {
    //       headers: { "Content-Type": "multipart/form-data" },
    //     }
    //   );
    //   return response.data.data;
    // } catch (error) {
    //   console.error("Erro ao enviar arquivo:", error);
    //   return [];
    // }
  };

  const addDependent = () => {
    setDependents([
      ...dependents,
      { nome: "", telefone: "", cpf: "", email: "" },
    ]);
  };

  const removeDependent = (index: number) => {
    setDependents(dependents.filter((_, i) => i !== index));
  };

  const updateDependent = (index: number, field: string, value: string) => {
    setDependents((prev) =>
      prev.map((dependent, i) =>
        i === index ? { ...dependent, [field]: value } : dependent
      )
    );
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const renameFile = (file: File, newName: string): File => {
    return new File([file], newName, { type: file.type });
  };

  const handleConfirmClick = async () => {
    const { cpf, email, cidade, estado, cep, rua, numero, bairro, telefone } =
      formData;

    if (!cpf || !email || !cidade || !estado) {
      alert("Preencha todos os campos obrigatórios!");
      return;
    }

    try {
      const complemento = "";

      console.log(localStorage.getItem("id")!, "id");

      const responseAtt = await attInfoPF(
        localStorage.getItem("id")!,
        cep,
        rua,
        numero,
        complemento,
        bairro,
        parseInt(cidade),
        parseInt(estado),
        email,
        telefone
      );

      if (!responseAtt || responseAtt.length === 0) {
        alert("Erro ao atualizar cadastro.");
        return;
      }

      setIsDialogOpen(true);
    } catch (error) {
      console.error("Erro ao atualizar cadastro:", error);
      alert("Erro ao enviar o formulário. Tente novamente.");
    }
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handlePlansDropdown = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedIdCategory = event.target.value;
    setIdCategory(selectedIdCategory);
    console.log(selectedIdCategory);
  };

  return (
    <CrewStyle>
      <WrapContent>
        <BackButton onClick={() => navigate(HOME_LOGGED)}>
          <FaArrowLeft />
          Voltar
        </BackButton>
        <h1>PORTAL DO CLIENTE</h1>
        <h3>Atualização cadastral</h3>
        <BlurWrapper isBlurred={isDialogOpen}>
          <ChoosePlanCard>
            <FormContainer>
              <p>Atualize as informações necessárias.</p>
              <FormField>
                <FormInput
                  type="tel"
                  name="telefone"
                  placeholder="Telefone"
                  value={formData.telefone}
                  onChange={handleInputChange}
                />
              </FormField>
              <FormField>
                <FormInput
                  type="email"
                  name="email"
                  placeholder="E-mail"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </FormField>
              <FormField>
                <FormInput
                  type="text"
                  name="cep"
                  placeholder="CEP"
                  value={formData.cep}
                  onChange={handleInputChange}
                />
              </FormField>
              <FormField>
                <FormInput
                  type="text"
                  name="rua"
                  placeholder="Rua"
                  value={formData.rua}
                  onChange={handleInputChange}
                />
              </FormField>
              <FormRow>
                <FormField>
                  <FormInput
                    type="text"
                    name="bairro"
                    placeholder="Bairro"
                    value={formData.bairro}
                    onChange={handleInputChange}
                  />
                </FormField>
                <FormField>
                  <FormInput
                    type="text"
                    name="numero"
                    placeholder="Nº"
                    value={formData.numero}
                    onChange={handleInputChange}
                  />
                </FormField>
              </FormRow>
              <FormRow>
                <FormField>
                  <select
                    name="estado"
                    value={formData.estado}
                    onChange={handleInputChange}
                  >
                    <option value="" disabled>
                      Escolha o estado
                    </option>
                    {Array.from(estados).map((uf) => (
                      <option key={uf} value={uf}>
                        {uf}
                      </option>
                    ))}
                  </select>
                </FormField>
                <FormField>
                  <select
                    name="cidade"
                    value={formData.cidade}
                    onChange={handleInputChange}
                    disabled={!formData.estado}
                  >
                    <option value="" disabled>
                      Escolha a cidade
                    </option>
                    {municipios
                      .filter((m: any) => m.uf === formData.estado)
                      .map((m: any) => (
                        <option key={m.codigo} value={m.codigo}>
                          {m.nomeMunicipio}
                        </option>
                      ))}
                  </select>
                </FormField>
              </FormRow>
            </FormContainer>
            <ConfirmButton isExpanded={true} onClick={handleConfirmClick}>
              Concluir
            </ConfirmButton>
          </ChoosePlanCard>
        </BlurWrapper>
        <SuccessDialog2
          message="Atualização cadastral feita com sucesso!"
          isOpen={isDialogOpen}
          onClose={handleCloseDialog}
        />
      </WrapContent>
    </CrewStyle>
  );
}
